// reducer.js

// Action Types
export const TYPES = {
  INSPECTORS: 'INSPECTORS',
  SET_SCHEDULE: 'SET_SCHEDULE',
  SET_FILTERED_INSPECTORS: 'SET_FILTERED_INSPECTORS',
  SET_MAP: 'SET_MAP',
  CALENDAR: 'CALENDAR',
  PROJECTS: 'PROJECTS',
  AVAILABILITY: 'AVAILABILITY',
  INSPECTOR_AVAILABILITY: 'INSPECTOR_AVAILABILITY',
  PUSH_DATA: 'PUSH_DATA',
  ADD_NOTE: 'ADD_NOTE',
  CHANGE_NOTE: 'CHANGE_NOTE',
  UPDATE_PROJECTS: 'UPDATE_PROJECTS',
  SET_FROM: 'SET_FROM',
  SET_SIZE: 'SET_SIZE',
  RESET: 'RESET',
};

export const initialState = {
  projects: {},
  inspectors: {},
  availability: {},
  calendar: [],
  time: null,
  date: null,
  duration: null,
  project: {},
  inspector: {},
  projectQuery: {},
  inspectorQuery: {},
  inspectorAvailability: {},
  mapping: {
    map: null,
    filteredInspectors: {},
  },
  schedule: null, // Added this to initial state as it was in your reducer logic
  updateProjects: false,
  from: 0,
  size: 1000,
};

export default function scheduleReducer(state = initialState, action) {
  switch (action.type) {

    case TYPES.RESET:
      return initialState;

    case TYPES.INSPECTORS:
      return { ...state, inspectors: action.payload };
      
    case TYPES.SET_SCHEDULE:
      return { ...state, schedule: action.payload };
      
    case TYPES.SET_FILTERED_INSPECTORS:
      return {
        ...state,
        mapping: { ...state.mapping, filteredInspectors: action.payload },
      };
      
    case TYPES.SET_MAP:
      return {
        ...state,
        mapping: { ...state.mapping, map: action.payload },
      };
      
    case TYPES.CALENDAR:
      return { ...state, calendar: action.payload };
      
    case TYPES.PROJECTS: 
      console.log('Reducer PROJECTS action.payload', action.payload);
      return { ...state, projects: action.payload };
      
    case TYPES.AVAILABILITY:
      return { ...state, availability: action.payload };
      
    case TYPES.INSPECTOR_AVAILABILITY:
      return { ...state, inspectorAvailability: action.payload };
      
    case TYPES.PUSH_DATA:
      // Spreads the payload directly into state
      return { ...state, ...action.payload };
      
    case TYPES.ADD_NOTE: {
      const newProject = { ...state.project };
      const newNotes = newProject.siteNotes ? [...newProject.siteNotes] : [];
      newNotes.push(action.payload);
      return { ...state, project: { ...newProject, siteNotes: newNotes } };
    }

    case TYPES.CHANGE_NOTE: {
      const { index, value } = action.payload;
      const newProject = { ...state.project };
      const newNotes = newProject.siteNotes ? [...newProject.siteNotes] : [];
      newNotes.splice(index, 1, value);
      return { ...state, project: { ...newProject, siteNotes: newNotes } };
    }

    case TYPES.UPDATE_PROJECTS:
      return { ...state, updateProjects: !state.updateProjects };
      
    case TYPES.SET_FROM:
      return { ...state, from: action.payload };
      
    case TYPES.SET_SIZE:
      return { ...state, size: action.payload };
      
    default:
      return state;
  }
}